import { ApiResourceModel } from "../ApiResourceModel";
/**
 * Represents the user's model based on the server's retrieved data.
 */
export class User extends ApiResourceModel {
    constructor(args = {}) {
        super();
        this.id = args.id || args.userId;
        this.clientId = args.clientId;
        this.username = args.username;
        this.email = args.email || "";
        this.password = args.password || "";
        this.firstName = args.firstName || this.username;
        this.lastName = args.lastName || "";
        this.topic = args.topic;
        this.organization = args.organization || "";
        this.guest = !{}.hasOwnProperty.call(args, "guest") || !!args.guest;
        this.authorities = args.authorities;
    }
}
//# sourceMappingURL=User.js.map